/**
 * RFC 7807 problem `type` URIs for contact business errors. Match on these via
 * `getApiError(error)`. Mirrors the backend `App\Contact\Enum\ContactErrorType`.
 */
export const ContactErrorType = {
  AccessDenied: '/errors/contact-access-denied'
} as const

export type ContactErrorType =
  (typeof ContactErrorType)[keyof typeof ContactErrorType]
